import * as React from 'react'
import { ValueType } from 'react-select'

import { renderDropDown } from 'app/components/DropDown'
import { ReactBlocks } from 'app/helpers/Blocks'
import { observeLazyLoadedChildrenImages } from 'app/helpers/observer'
import SingleColumnLayout from 'app/layouts/SingleColumnLayout'
import { TPageData } from 'app/service/api/theme'

interface IProps {
  pageData: TPageData<'page'>
}

declare let wpcf7: any

interface IOption {
  value: string
  label: string
}

const Page: React.FC<IProps> = ({ pageData }) => {
  const blocks = pageData as any[]

  const [selectValue, setSelectValue] = React.useState<ValueType<IOption, false>>()

  const options: IOption[] = []

  const renderSelect = (cf7Select: Element) => {
    const cf7Name = cf7Select.getAttribute('name')!
    const cf7Options = cf7Select.getElementsByTagName('option')
    for (let i = 0; i < cf7Options.length; i++) {
      options.push({ value: cf7Options[i].value, label: cf7Options[i].innerHTML })
    }

    const container = cf7Select.parentElement!

    renderDropDown(cf7Name, options, container, selectValue, setSelectValue, () => {
      const breakLines = container.parentElement!.getElementsByTagName('br')
      breakLines && breakLines.length > 1 && breakLines[1].remove()
      if (window.location.hash) {
        const elmnt = document.querySelector(window.location.hash)!
        elmnt && elmnt.scrollIntoView({ behavior: 'smooth' })
      }
    })
  }

  const renderForm = (cf7Form: Element) => () => {
    !document.querySelector('.wpcf7-form.init') && wpcf7.initForm(cf7Form)
    const cf7Select = document.querySelector('.wpcf7-select')
    cf7Select && renderSelect(cf7Select)
  }

  const renderCF7 = () => {
    const cf7Forms = document.querySelectorAll('form.wpcf7-form')
    cf7Forms.forEach((cf7Form) => {
      setTimeout(renderForm(cf7Form), 0)

      if (cf7Form.parentElement && cf7Form.parentElement.querySelector('.with-success-block')) {
        cf7Form.parentElement.addEventListener(
          'wpcf7submit',
          function (evt) {
            const successForm = cf7Form.parentElement?.parentElement?.parentElement?.querySelector('.cf7-success')
            if ((evt as any).detail.apiResponse.status !== 'validation_failed') {
              successForm && successForm.classList.remove('d-none')
              cf7Form.parentElement?.parentElement?.remove()
            } else {
              cf7Form.parentElement?.parentElement?.querySelector('.wpcf7-response-output')?.remove()
            }
          },
          false,
        )
      }
    })
  }

  React.useEffect(() => {
    renderCF7()
    observeLazyLoadedChildrenImages(document)
  })

  return (
    <SingleColumnLayout>
      <React.Suspense>
        <ReactBlocks innerBlocks={blocks} withoutClientOnly />
      </React.Suspense>
    </SingleColumnLayout>
  )
}

export default Page
